import { bindable, customElement } from "aurelia-templating";

@customElement("report-general-information")
export class ReportGeneralInformation {
    @bindable
    public reportTitle: string;
    @bindable
    public surveyName: string;
    @bindable
    public name: string;
    @bindable
    public company: string;
    @bindable
    public created: Date;
}
